import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import classNames from 'classnames'
import DropdownMenu from 'desktop/components/layout/dropdown_menu'
import Event from 'base/event'
import RouterLink from 'base/components/router_link'
import setEvents from './menu_helpers'

const defaultEventProperties = {
  type: 'text',
  placement: 'top',
}

class MenuItem extends Component {
  static propTypes = {
    position: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    submenus: PropTypes.arrayOf(PropTypes.object).isRequired,
    currentPath: PropTypes.string.isRequired,
    children: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    opensInNewWindow: PropTypes.bool,
    isIpad: PropTypes.bool.isRequired,
    showHoliday: PropTypes.bool,
    shouldUseColor: PropTypes.bool.isRequired,
    gender: PropTypes.string,
    // mark as required once on builder menus
    images: PropTypes.arrayOf(PropTypes.object),
    mainNavTextColor: PropTypes.string,
  }

  state = {
    showDropdownMenu: false,
  }

  handleAddClassname(className, innerText) {
    const allOtherLeftSideMenus = [...document.querySelectorAll(className)].filter(
      item => item.innerText !== innerText,
    )

    allOtherLeftSideMenus.forEach(menu =>
      menu.firstChild.classList.add('app-header__menu-item-link-text--dimmed'),
    )
  }

  handleRemoveClassname(className, innerText) {
    const allOtherLeftSideMenus = [...document.querySelectorAll(className)].filter(
      item => item.innerText !== innerText,
    )

    allOtherLeftSideMenus.forEach(menu =>
      menu.firstChild.classList.remove('app-header__menu-item-link-text--dimmed'),
    )
  }

  handleMouseEnter = (event, eventProperties) => {
    if (!eventProperties && (this.props.submenus.length || this.isCustomMenu())) {
      this.setState({ showDropdownMenu: true })
      setEvents({
        ...defaultEventProperties,
        eventName: Event.Navigation.DROP_DOWN_OPENED,
        name: this.props.name,
        url: this.props.url,
        ...eventProperties,
      })

      this.handleAddClassname('a.app-header__menu-item-link', event.target.innerText)
    }
  }

  handleMouseLeave = event => {
    // Fix for edgecases where the mouse might leave the menu item while moving diagonally
    // towards the dropdown
    const mouseInHeader = event.relatedTarget.className === 'app-header__left'

    if (!mouseInHeader && (this.props.submenus.length || this.isCustomMenu())) {
      this.setState({ showDropdownMenu: false })
    }

    this.handleRemoveClassname('a.app-header__menu-item-link', event.target.innerText)
  }

  isCustomMenu() {
    return ['About', 'The Gift Shop'].includes(this.props.name)
  }

  handleMenuItemClick = eventProperties => {
    this.hideDropdownAfterSlightDelay()
    setEvents({
      ...defaultEventProperties,
      eventName: Event.Navigation.LINK_CLICK,
      name: this.props.name,
      url: this.props.url,
      ...eventProperties,
    })
  }

  // When a user selects an option from our dropdown menu, we'd like to hide ourselves.
  // Hiding directly after a click makes it seem like something broke, so we delay slightly
  // to fake "waiting for the network"
  hideDropdownAfterSlightDelay() {
    setTimeout(() => this.setState({ showDropdownMenu: false }), 500)
  }

  render() {
    const linkTarget = this.props.opensInNewWindow ? '_blank' : '_self'
    const hasSubmenus = this.props.submenus.length > 0

    const shouldNotLink = this.props.isIpad && hasSubmenus
    const linkClass = classNames('app-header__menu-item-link')

    const menuTitle = (
      <RouterLink
        className={linkClass}
        target={linkTarget}
        href={shouldNotLink ? null : this.props.url}
        onMouseEnter={this.handleMouseEnter}
        onClick={this.handleMenuItemClick}
      >
        {/* CSS targets this class when styling hover-state */}
        <div
          style={{ color: this.props.mainNavTextColor }}
          className="app-header__menu-item-link-text"
        >
          {this.props.children}
        </div>
      </RouterLink>
    )

    const submenus = this.props.submenus.filter(menu => menu.name !== 'Denim')

    return (
      <Fragment>
        <div className="app-header__menu-item" onMouseLeave={this.handleMouseLeave}>
          {menuTitle}

          <DropdownMenu
            isVisible={this.state.showDropdownMenu}
            currentPath={this.props.currentPath}
            menuName={this.props.name}
            menus={submenus}
            onClickItem={this.handleMenuItemClick}
            onMouseEnterItem={this.handleMouseEnter}
            leftAlign
            images={this.props.images}
          />
        </div>
      </Fragment>
    )
  }
}

export default MenuItem
